define((require) => {
    "use strict";

    const Browser                         = require("shared/services/Browser");
    const SalesforceCommerceWidgetModel   = require("shared/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceWidgetModel");
    const Marionette                      = require("marionette");
    const template                        = require("ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceProductView.tpl");

    /**
     * ItemView containing a SalesforceCommerce product.
     *
     * @class SalesforceCommerceProductView
     * @constructor
     */
    return Marionette.ItemView.extend({

        template: template,

        className: "salesforce-commerce-item fade-in",

        modelEvents: {
            "change:isUsed": "render"
        },

        ui: {
            image: "img"
        },

        events: {
            "click": function() {
                // Trigger a "select" event on the 'this' element, this will allow the parent
                // view to easily setup a "select" listener, like <tt>events: {"select .salesforce-commerce-image": function...}</tt>
                this.$el.trigger("select", this.model);
            },

            "dragstart": "_dragHandler"
        },

        _dragHandler(event) {
            if (this.options.draggable) {
                this.ui.image.attr("draggable", "true");
            }

            // Firefox has a bug that causes it to offset the dragged image when displayed in a lightbox. Workaround is
            // to explicitly set the drag image to the dragged element.
            if (Browser.type.firefox) {
                event.originalEvent.dataTransfer.setDragImage(this.el, this.$el.width() / 2, this.$el.height() / 2);
            }

            const data = {
                type: "demandware",
                options: {
                    productID: this.model.get("productID"),
                    width: SalesforceCommerceWidgetModel.FIXED_SIZE.width,
                    height: SalesforceCommerceWidgetModel.FIXED_SIZE.height
                }
            };

            // The setData method will work across all browsers. Unfortunately only supports
            // string as data rather than JSON objects, so we need to split the result.
            event.originalEvent.dataTransfer.setData("Text", JSON.stringify(data));
        },

        onRender() {
            // No deferred here, the error event can already have happened...

            // Add img error handler function.
            this.ui.image.on("error", () => {
                this.ui.image.hide();

                this.$(".no-image").toggleClass("hide");
            });
        },

        // Reverts the error handler from img.
        onClose() {
            this.ui.image.off("error");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceProductView.js